import React from "react";
import styled from "styled-components";
import { ASSETS } from "../../../../utils/config";

import { TextView } from "../../../../components";
// Styled components
const MediaBox = styled.div`
  background-color: ${({ isVisible }) => (isVisible ? "#123051" : "#F6F7F9")};
  height: 4vh;
  cursor: pointer;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  padding-right: 7px;
  margin-left: 30vw;
  margin-right: 30vw;
`;

const MediaImage = styled.img`
  height: 4vh;
  width: 4vw;
  margin-right: 6px;
`;

const MediaText = styled(TextView)`
  cursor: pointer;
  font-weight: 500;
  text-transform: capitalize;
  color: ${({ isVisible }) => (isVisible ? "white" : "#123051")};
`;

function MediaButton({ isVisible, onButtonClick = () => {} }) {
  return (
    <>
      {isVisible ? (
        <MediaBox onClick={onButtonClick} isVisible={isVisible}>
          <MediaImage src={ASSETS.MediaWhite} alt="media" />
          <MediaText isVisible={isVisible}>Hide Media Box</MediaText>
        </MediaBox>
      ) : (
        <MediaBox onClick={onButtonClick} isVisible={isVisible}>
          <MediaImage src={ASSETS.MediaBlueIcon} alt="media" />
          <MediaText isVisible={isVisible}>Show Media Box</MediaText>
        </MediaBox>
      )}
    </>
  );
}

export default MediaButton;
